module.exports = __webpack_public_path__ + "static/media/qr-write-buy-india.475623d9.png";